import PhysicalExerciseService from '@/bundles/VideoContent/services/PhysicalExerciseService';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { http } from '@/bundles/Http/factory/HttpFactory';

function physicalExerciseServiceFactory() {
  return new PhysicalExerciseService({
    errorMapper: new ErrorMapper(),
    transport: http,
  });
}

export const physicalExerciseService = physicalExerciseServiceFactory();
